'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FilterButton } from '@lichtblick/photon/atoms/filter-button';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { CrossXs } from '@lichtblick/photon/icons/symbols/cross-xs';
import classNames from 'classnames';
import React, { useId, useMemo, useState } from 'react';
import styles from '../OTeaserGrid/o-teaser-grid.module.scss';
import filterStyles from './filter-styles.module.scss';
// has to be a client component to make props accessible via React.Children.toArray
export const FilterableArticle = ({ children })=>children;
export const ArticleFilter = ({ anchorId, children, theme })=>{
    const [currentCategory, setCurrentCategory] = useState(new URLSearchParams(typeof window !== 'undefined' ? window.location.search : undefined).get('kategorie'));
    const fallbackId = useId();
    const id = anchorId ?? fallbackId;
    const categories = useMemo(()=>{
        const usedCategories = React.Children.toArray(children).filter((child)=>/*#__PURE__*/ React.isValidElement(child)).flatMap((article)=>article.props.categories ?? []).filter((value)=>typeof value === 'string');
        return usedCategories.filter((value, index, array)=>{
            return array.indexOf(value) === index;
        }).sort();
    }, [
        children
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                "aria-label": "Liste von Kategorien zum Filtern der Artikel",
                className: filterStyles.wrapper,
                role: "group",
                children: [
                    categories.map((category)=>/*#__PURE__*/ _jsx(FilterButton, {
                            active: category === currentCategory,
                            "aria-controls": id,
                            onClick: ()=>{
                                setCurrentCategory(category !== currentCategory ? category : null);
                            },
                            children: category
                        }, category)),
                    Boolean(currentCategory) && /*#__PURE__*/ _jsx(TextCTA, {
                        "aria-controls": `${id}-list`,
                        as: "button",
                        className: filterStyles.reset,
                        icon: /*#__PURE__*/ _jsx(CrossXs, {}),
                        onClick: ()=>{
                            setCurrentCategory(null);
                        },
                        slim: true,
                        type: "button",
                        children: "Filter zurücksetzen"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(styles.section, styles[`section-bg-${theme}`], styles[`section-cols-${children.length > 2 ? '3' : '2'}`], styles['section-masonry']),
                "data-testid": "teaser-grid",
                id: id,
                children: React.Children.toArray(children).filter((child)=>/*#__PURE__*/ React.isValidElement(child)).filter((child)=>currentCategory === null || child.props.categories?.includes(currentCategory))
            })
        ]
    });
};

//# sourceMappingURL=article-filter.js.map